@import '../styles/_vars.css';

.footer {
  padding: 3rem 0 3rem;
  border-top: 1px solid #e8e5e4;
}

.footerContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.left {
  text-align: center;
}

.right{
  display: flex;
  justify-content: flex-end;
  column-gap: 1em;
}

@media screen and (min-width: 770px) {
  .footerContent {
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
  }

  .right{
    column-gap: 1.625em;
  }
}

